import type { ModId, Reg, Task } from '../store/types';
import { getDoc, setDoc } from '../store/store';
import { newTask } from '../store/planner';
import { mudarReg } from '../store/modulos';
import { today } from '../lib/date';
import { t } from '../lib/i18n';

/** Horários digitados ("8h, 14:30 e 20") viram ["08:00", "14:30", "20:00"]. */
export function lerHorarios(txt: string): string[] {
  const out = new Set<string>();
  for (const m of String(txt || '').matchAll(/(\d{1,2})\s*(?:[:h.]\s*(\d{2}))?/gi)) {
    const h = Number(m[1]), mi = Number(m[2] ?? 0);
    if (h < 24 && mi < 60) out.add(`${String(h).padStart(2, '0')}:${String(mi).padStart(2, '0')}`);
  }
  return [...out].sort();
}

export type Rotina = { titulo: string; emoji: string; hora: string | null; cada: number; inicio?: string; fim?: string | null; insistente?: boolean; notas?: string; energia?: number;
  alto?: boolean };   // alto: toca mesmo no silencioso e no Não perturbe (remédio, 0.70 E1); sem = igual a insistente

/** Cria (ou recria) tarefas repetidas no My Planner ligadas a um registro (remédio, rega, adubo...).
 *  As tarefas antigas desse registro são trocadas pelas novas, mantendo o que já foi marcado como feito. */
export function criarRotinas(mod: ModId, r: Reg, rotinas: Rotina[]) {
  const antigas: string[] = Array.isArray(r.c._tarefas) ? r.c._tarefas : [];
  const tasks = getDoc('planner').tasks;
  const novas: Task[] = rotinas.map((x, i) => {
    const velha = tasks.find(tk => tk.id === antigas[i]);
    const cada = Math.max(1, Math.round(x.cada || 1));
    return newTask({
      ...(velha ? { id: velha.id, done: velha.done, skip: velha.skip, subDone: velha.subDone, createdAt: velha.createdAt } : {}),
      title: x.titulo, emoji: x.emoji, emojiManual: true, area: mod, start: x.inicio || today(), end: x.fim || null,
      time: x.hora, duration: 10, energy: x.energia ?? 1, notes: x.notas ?? '',
      recur: cada === 1 ? { type: 'daily' } : cada === 7 ? { type: 'weekly' } : { type: 'custom', every: cada },
      alerts: x.hora ? { mode: 'start', before: [], itens: [{ tipo: 'inicio' }] } : { mode: 'none', before: [], itens: [{ tipo: 'hora', hora: '09:00' }] },
      insistente: !!x.insistente, ...(x.alto != null ? { alarmeAlto: x.alto } : {}), link: { aba: mod, id: r.id, label: x.titulo },
    });
  });
  const ids = new Set(novas.map(n => n.id));
  setDoc('planner', d => ({ tasks: [...d.tasks.filter(tk => !antigas.includes(tk.id) && !ids.has(tk.id)), ...novas.map(n => ({ ...n, updatedAt: new Date().toISOString() }))] }));
  mudarReg(mod, r.id, x => ({ ...x, c: { ...x.c, _tarefas: novas.map(n => n.id) } }));
  return novas.length;
}

/** Tira do My Planner as tarefas criadas por este registro. */
export function tirarRotinas(mod: ModId, r: Reg) {
  const antigas: string[] = Array.isArray(r.c._tarefas) ? r.c._tarefas : [];
  if (!antigas.length) return;
  setDoc('planner', d => ({ tasks: d.tasks.filter(tk => !antigas.includes(tk.id)) }));
  mudarReg(mod, r.id, x => ({ ...x, c: { ...x.c, _tarefas: [] } }));
}
export const temRotinas = (r: Reg) => Array.isArray(r.c._tarefas) && r.c._tarefas.length > 0
  && getDoc('planner').tasks.some(tk => r.c._tarefas.includes(tk.id));
export const avisoRotinas = (n: number) => t('{n} lembrete(s) colocado(s) no My Planner.', { n });
